import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CancelPopUp from '../CancelPopUp/index';
import styles from './editCancelButtons.module.css';

class EditCancelButtons extends Component {
  static propTypes = {
    closePopUp: PropTypes.func.isRequired,
  };
  state = {
    cancelIsClicked: false,
  };
  toggleClick = () => {
    this.setState({ cancelIsClicked: !this.state.cancelIsClicked });
  };
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.buttonContainer}>
          <button onClick={this.props.closePopUp} className={styles.buttons}>
            Change Date or Time
          </button>
          <button onClick={this.toggleClick} className={styles.buttons}>
            Cancel
          </button>
        </div>
        {this.state.cancelIsClicked && (
          <CancelPopUp
            toggleClick={this.toggleClick}
            closePopUp={this.props.closePopUp}
          />
        )}
      </div>
    );
  }
}

export default EditCancelButtons;
